import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HeadingForLargePromo from "./HeadingForLargePromo";
import Image from "./Image";
import PropTypes from "prop-types";
import React from "react";

function LargeHeadingImageSection({ heading, image, mobImage, bg, children }) {
  return (
    <Box pb={[60, null, 130, null]} bg={bg}>
      <Box position="relative" height={0} pb={[300, null, 490, null]}>
        <Image
          src={image.url}
          alt={image.title}
          imgHeight={image.height}
          imgWidth={image.width}
          height="100%"
          width="100%"
          position="absolute"
          top={0}
          left={0}
          objectFit="cover"
          objectPosition="50% 0%"
          display={["none", "initial", null, null]}
          bg="lightGrey"
        />
        <Image
          src={mobImage.url}
          alt={mobImage.title}
          imgHeight={mobImage.height}
          imgWidth={mobImage.width}
          height="100%"
          width="100%"
          position="absolute"
          top={0}
          left={0}
          objectFit="cover"
          objectPosition="50% 0%"
          display={["initial", "none", null, null]}
          bg="lightGrey"
        />
        <Box
          position="absolute"
          height="100%"
          width="100%"
          top={0}
          left={0}
          display="flex"
          flexDirection="column"
          justifyContent="flex-end"
        >
          {heading && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flex={1}
            >
              <Box maxWidth={[350, null, "100%", null]}>
                <HeadingForLargePromo>{heading}</HeadingForLargePromo>
              </Box>
            </Box>
          )}
          <Box display="flex" justifyContent="flex-end">
            <Box bg={bg} height={[45, null, 100, null]} width="52%" />
          </Box>
        </Box>
      </Box>
      <BoxWithGutter pt={[38, null, 100, null]}>{children}</BoxWithGutter>
    </Box>
  );
}

LargeHeadingImageSection.propTypes = {
  heading: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
  }).isRequired,
  mobImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
  }).isRequired,
  bg: PropTypes.string.isRequired,
};

export default LargeHeadingImageSection;
